import { textAtomTypeId } from '@/enums';
import { useEntityTextSave } from './useEntityTextSave';

interface UpdateFragmentSynopsisData {
    fragmentId: number;
    content: string;
    textAtomId?: number;
}

export function useUpdateFragmentSynopsis() {
    return useEntityTextSave<UpdateFragmentSynopsisData>({
        entity: 'fragment',
        action: 'updateSynopsis',
        typeId: textAtomTypeId.episode_plot,
        entityIdOf: ({ fragmentId }) => fragmentId,
    });
}
